import { render } from "./UtlitiesMenuApps.vue?vue&type=template&id=14b53ec6&scoped=true"
import script from "./UtlitiesMenuApps.vue?vue&type=script&lang=js"
export * from "./UtlitiesMenuApps.vue?vue&type=script&lang=js"

import "./UtlitiesMenuApps.vue?vue&type=style&index=0&id=14b53ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b53ec6"]])

export default __exports__